"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GetOctetArray_1 = require("./GetOctetArray");
var Mask_1 = require("./Mask");
function networkAddress(subnet) {
    var maskOctets = GetOctetArray_1.getOctetArray(Mask_1.mask(subnet));
    var ipOctets = GetOctetArray_1.getOctetArray(subnet.split('/')[0]);
    var networkAddress = '';
    for (var i = 0; i < 4; i++) {
        var currMaskOctet = parseInt(maskOctets[i], 10);
        var currIpOctet = parseInt(ipOctets[i], 10);
        networkAddress = networkAddress.concat(String(currMaskOctet & currIpOctet));
        if (i !== 3) {
            networkAddress = networkAddress.concat('.');
        }
    }
    return networkAddress;
}
exports.networkAddress = networkAddress;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTmV0d29ya0FkZHJlc3MuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJOZXR3b3JrQWRkcmVzcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLGlEQUErQztBQUMvQywrQkFBNkI7QUFFN0Isd0JBQWdDLE1BQWM7SUFDNUMsSUFBSSxVQUFVLEdBQUcsNkJBQWEsQ0FBQyxXQUFJLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQTtJQUM1QyxJQUFJLFFBQVEsR0FBRyw2QkFBYSxDQUFDLE1BQU0sQ0FBQyxLQUFLLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQTtJQUNsRCxJQUFJLGNBQWMsR0FBRyxFQUFFLENBQUE7SUFDdkIsR0FBRyxDQUFDLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxFQUFFLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBQyxFQUFFLEVBQUUsQ0FBQztRQUMzQixJQUFJLGFBQWEsR0FBRyxRQUFRLENBQUMsVUFBVSxDQUFDLENBQUMsQ0FBQyxFQUFFLEVBQUUsQ0FBQyxDQUFBO1FBQy9DLElBQUksV0FBVyxHQUFHLFFBQVEsQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFDLEVBQUUsRUFBRSxDQUFDLENBQUE7UUFDM0MsY0FBYyxHQUFHLGNBQWMsQ0FBQyxNQUFNLENBQUMsTUFBTSxDQUFDLGFBQWEsR0FBRyxXQUFXLENBQUMsQ0FBQyxDQUFBO1FBQzNFLEVBQUUsQ0FBQyxDQUFDLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFDO1lBQ1osY0FBYyxHQUFHLGNBQWMsQ0FBQyxNQUFNLENBQUMsR0FBRyxDQUFDLENBQUE7UUFDN0MsQ0FBQztJQUNILENBQUM7SUFDRCxNQUFNLENBQUMsY0FBYyxDQUFBO0FBQ3ZCLENBQUM7QUFiRCx3Q0FhQyJ9


//////////////////
// WEBPACK FOOTER
// ./src/NetworkAddress.ts
// module id = 1
// module chunks = 0